import { ProFormaModelIds } from 'constants/proForma';
import { AssumptionsMetricId } from './metrics';
import { SectionDescriptor, LayoutContext, RowDescriptor } from './types';

export const SINGLE_VALUE_COLUMNS = [''] as const;

type Columns = typeof SINGLE_VALUE_COLUMNS;
type AssumptionsRow = RowDescriptor<AssumptionsMetricId, Columns>;

const effectiveRentRows = ({ proFormaModelId }: LayoutContext): AssumptionsRow[] => {
    if (proFormaModelId === ProFormaModelIds.APARTMENT) {
        return [
            { id: 'per-rsf', label: 'Per $/RSF/mo', cells: [{ metric: 'effectiveRentPerSf' }] },
            { id: 'per-unit', label: 'Per $/unit/mo', cells: [{ metric: 'effectiveRentPerUnit' }] },
        ];
    }
    return [];
};

export const assumptionsLayout = (context: LayoutContext): SectionDescriptor<AssumptionsMetricId, Columns>[] => [
    {
        id: 'effective-rent-section',
        title: 'Effective rent',
        columns: SINGLE_VALUE_COLUMNS,
        rows: effectiveRentRows(context),
    },
    {
        id: 'annual-growth-rate-section',
        title: 'Annual growth rate',
        columns: SINGLE_VALUE_COLUMNS,
        rows: [
            { id: 'rental-income', label: 'Rental income', cells: [{ metric: 'rentalIncomeGrowth' }] },
            { id: 'expenses', label: 'Expenses', cells: [{ metric: 'expensesGrowth' }] },
        ],
    },
    {
        id: 'income-adjustments-section',
        title: 'Income adjustments',
        columns: SINGLE_VALUE_COLUMNS,
        rows: [
            { id: 'general-vacancy', label: 'General vacancy', cells: [{ metric: 'generalVacancy' }] },
            { id: 'credit-loss', label: 'Credit loss', cells: [{ metric: 'creditLoss' }] },
        ],
    },
];
